import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { setUnauthorizedHandler } from '../../api/authEvents';
import { useAuth } from '../../auth/AuthContext';
import { useFeedback } from '../common/FeedbackProvider';

const EXPIRED_MESSAGE = 'Please sign in — your session has expired.';

/**
 * Wires API 401s to logout + redirect to /login with a toast.
 * Must render inside BrowserRouter, AuthProvider, and FeedbackProvider.
 */
export function AuthSessionBridge() {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const { showError } = useFeedback();

  useEffect(() => {
    setUnauthorizedHandler((message = EXPIRED_MESSAGE) => {
      const from = `${window.location.pathname}${window.location.search}`;
      void (async () => {
        await logout();
        showError(message);
        navigate('/login', {
          replace: true,
          state: { authMessage: message, from },
        });
      })();
    });
    return () => setUnauthorizedHandler(null);
  }, [logout, navigate, showError]);

  return null;
}
